import { getUserConfiguration } from 'owa-session-store';
import { loadTheme } from 'owa-theme';
export default function discardThemeChange() {
    loadTheme(getUserConfiguration().UserOptions.ThemeStorageId);
}
//# sourceMappingURL=discardThemeChange.js.map